import React, { useContext } from 'react';
import { bool, oneOf } from 'prop-types';
import useStyles from 'hooks/useStyles';
import CourseContext from 'routes/course/components/CourseContext';
import { CloseIcon } from 'components/Icon';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './CourseMeta.scss';
import { useTranslation } from 'react-i18next';

const SIZE = ['large', 'small'];

const getLessonI18nKey = lessonsAmount => {
  if (lessonsAmount > 1) return 'videoplayer.lesson_plural';
  return 'videoplayer.lesson';
};

function CourseMeta({ size, showClose }) {
  useStyles(styles);
  const { t } = useTranslation(['course']);
  const {
    lessonsAmount,
    lessonMeta: { durationTotal },
    onLessonListPopupModeClose,
  } = useContext(CourseContext);

  const { hours, minutes } = durationTotal;

  return (
    <div className={styles.root}>
      <div className={styles[size]}>
        {t(getLessonI18nKey(lessonsAmount), { count: lessonsAmount })}・
        {t('videoplayer.time', { hours, minutes })}
      </div>
      {showClose && (
        <div className={styles.icon} onClick={onLessonListPopupModeClose}>
          <CloseIcon />
        </div>
      )}
    </div>
  );
}

CourseMeta.propTypes = {
  size: oneOf(SIZE),
  showClose: bool,
};

CourseMeta.defaultProps = {
  size: SIZE[0],
  showClose: false,
};

export default CourseMeta;
